const services = [
  {
    slug: "general-electrical-auckland",
    name: "General Electrical Services",
    headline: "Licensed Electricians for Residential, Commercial & Industrial Auckland",
    metaTitle: "General Electrical Services Auckland | CyberElectrix",
    metaDescription: "Licensed Auckland electricians for installations, renovations, repairs, upgrades & EV charging. Residential, commercial & industrial. Call CyberElectrix.",
    description: "Safe and reliable electrical installations, renovations, repairs, upgrades, isolations and demolitions for residential, commercial, and industrial buildings and facilities across Auckland. This includes specialised appliances such as EV charging systems, switchboard upgrades, data cabling, and security lighting.",
    benefits: [
      "Full residential wiring and renovation electrical work",
      "Commercial and industrial electrical contracting",
      "Switchboard and consumer unit upgrades",
      "EV charging station installation (home & commercial)",
      "Data cabling and structured wiring",
      "Security and outdoor lighting installation",
      "Electrical fault finding and repairs",
      "Licensed and insured for all work types"
    ],
    icon: "fa fa-bolt",
    keywords: ["electrician Auckland", "electrical contractor Auckland", "switchboard upgrade Auckland", "EV charger installation Auckland", "residential electrician Auckland", "commercial electrician Auckland", "data cabling Auckland"],
    faqs: [
      {
        question: "How much does it cost to hire an electrician in Auckland?",
        answer: "Auckland electricians typically charge $80–$150 per hour plus materials, depending on job type and complexity. CyberElectrix offers free, no-obligation quotes — contact us for a competitive rate on residential, commercial, or industrial work."
      },
      {
        question: "Do I need a permit for electrical work in New Zealand?",
        answer: "Most prescribed electrical work requires a permit (Form WS) issued by your licensed electrician before work begins. This covers new circuits, switchboard work, and most wiring jobs. CyberElectrix handles all permit requirements as part of every job."
      },
      {
        question: "How long does a switchboard upgrade take?",
        answer: "Most residential switchboard upgrades are completed within a single working day. Commercial and industrial upgrades vary — we'll give you a realistic timeframe when we quote the job."
      },
      {
        question: "Can I do my own electrical work in NZ?",
        answer: "In New Zealand, prescribed electrical work must be carried out by a licensed electrician. DIY electrical work beyond replacing fittings and light bulbs is illegal and dangerous — fines and insurance voidance apply."
      }
    ]
  },
  {
    slug: "solar-pv-auckland",
    name: "Solar PV & Energy Efficiency",
    headline: "Solar Panel Installation & Energy Savings for Auckland Homes & Businesses",
    metaTitle: "Solar PV Installation Auckland | CyberElectrix",
    metaDescription: "Solar PV & BESS installations, hot water cylinder timers, LED retrofits & energy audits in Auckland. Reduce your power bill with CyberElectrix.",
    description: "Solar photovoltaic (PV) and battery energy storage system (BESS) installations with hot water cylinder integration, LED lighting retrofits, smart monitoring meters, and energy audits. We help Auckland homes and businesses reduce electricity costs while contributing to a sustainable future.",
    benefits: [
      "Rooftop solar PV system design and installation",
      "Battery energy storage system (BESS) integration",
      "Hot water cylinder timer and smart relay installation",
      "LED lighting retrofit for homes and businesses",
      "Energy audit and power consumption analysis",
      "Solar + grid-tie inverter setup",
      "Smart monitoring meter installation",
      "Safety-code-compliant Solar PV installations"
    ],
    icon: "fa fa-leaf",
    keywords: ["solar panel installation Auckland", "solar PV Auckland", "BESS installation Auckland", "hot water cylinder timer Auckland", "LED lighting retrofit Auckland", "energy efficiency Auckland", "solar energy Auckland"],
    faqs: [
      {
        question: "How much does solar panel installation cost in Auckland?",
        answer: "A typical residential solar PV installation in Auckland costs $8,000–$20,000, depending on array size, inverter type, and whether battery storage (BESS) is included. Contact CyberElectrix for a tailored quote based on your roof and energy usage."
      },
      {
        question: "How long until solar pays for itself in NZ?",
        answer: "Payback periods typically range from 7–12 years depending on system size, your electricity usage patterns, and your energy retailer's buy-back rate. Battery storage can extend payback but significantly increases energy independence."
      },
      {
        question: "Does solar work on cloudy days in Auckland?",
        answer: "Yes. Modern solar panels generate power under overcast conditions — they respond to daylight, not direct sunlight. Auckland's weather reduces but does not eliminate solar generation. We'll assess your roof orientation and shading before recommending a system size."
      },
      {
        question: "What is BESS and do I need it with solar?",
        answer: "BESS (Battery Energy Storage System) stores excess solar generation for use at night or during grid outages. It's not essential but significantly increases your self-consumption rate and energy independence. We can advise on whether BESS stacks up financially for your situation."
      }
    ]
  },
  {
    slug: "smart-home-automation-auckland",
    name: "Smart Home & Office Automation",
    headline: "Intelligent Automation for Auckland Homes and Workspaces",
    metaTitle: "Smart Home Automation Auckland | CyberElectrix",
    metaDescription: "Smart home & office automation in Auckland — intelligent lighting, smart thermostats, security systems, IoT/IIoT integration. CyberElectrix installs it all.",
    description: "Transform your Auckland home or workspace with intelligent lighting, smart thermostats, security systems, and behaviour-learning devices. We design and install complete smart home and office automation systems — from simple timer switches to full IoT/IIoT integrated building management.",
    benefits: [
      "Smart lighting design and installation (LED, sensor, timer-controlled)",
      "Smart thermostat and climate control systems",
      "Home and office security system installation",
      "IoT and IIoT sensor integration",
      "Building automation system (BAS/BMS) installation",
      "Remote monitoring and control setup",
      "Behaviour-learning device configuration",
      "Retrofit smart systems into existing buildings"
    ],
    icon: "fa fa-home",
    keywords: ["smart home automation Auckland", "home automation Auckland", "smart lighting Auckland", "IoT integration Auckland", "building automation Auckland", "smart home installer Auckland", "intelligent home systems Auckland"],
    faqs: [
      {
        question: "What is home automation and what can it control?",
        answer: "Home automation connects your lighting, climate control, security, and appliances to a central system — allowing remote control, scheduling, and automated responses to conditions like occupancy, time of day, or ambient temperature. A single app can manage your entire home."
      },
      {
        question: "Can smart home systems be retrofitted to an older house?",
        answer: "Yes. Many modern smart home products are designed to work with existing wiring. We assess your current installation and recommend the best retrofit path — often without the need for full rewiring."
      },
      {
        question: "How much does a smart home installation cost in Auckland?",
        answer: "Costs range from a few hundred dollars for basic smart lighting to several thousand for a full BAS/BMS integration. We'll scope a solution that fits your budget and priorities, starting with the highest-impact changes first."
      },
      {
        question: "Does a smart home system work without the internet?",
        answer: "Basic functions — local switching, pre-set schedules, and motion-triggered lighting — typically work without internet. Remote access, voice assistant integration, and cloud-based automation require an active internet connection."
      }
    ]
  },
  {
    slug: "critical-power-infrastructure-auckland",
    name: "Critical Power Infrastructure",
    headline: "Backup Power, UPS & Generator Solutions for Auckland Businesses",
    metaTitle: "Critical Power Infrastructure Auckland | CyberElectrix",
    metaDescription: "Backup generator, ATS, UPS & battery bank installation, maintenance & monitoring in Auckland. Keep your business running with CyberElectrix.",
    description: "Backup generator, automatic transfer switch (ATS), uninterruptible power supply (UPS), and battery bank installation, maintenance, and optimisation — including communication circuit wiring and remote monitoring. We ensure your critical power systems protect your operations around the clock.",
    benefits: [
      "Backup generator installation and commissioning",
      "Automatic transfer switch (ATS) installation",
      "UPS system installation and battery replacement",
      "Industrial-scale battery bank installation",
      "Remote monitoring and control integration",
      "Preventive maintenance programmes",
      "Power quality analysis and optimisation",
      "Data centre and mission-critical power support"
    ],
    icon: "fa fa-power-off",
    keywords: ["backup generator Auckland", "UPS installation Auckland", "critical power infrastructure Auckland", "ATS installation Auckland", "battery bank Auckland", "uninterruptible power supply Auckland", "power backup Auckland"],
    faqs: [
      {
        question: "What is a UPS and why would I need one?",
        answer: "A UPS (Uninterruptible Power Supply) provides instant battery backup during power outages or voltage fluctuations, protecting servers, medical equipment, and industrial controls from data loss, hardware damage, and costly downtime. It bridges the gap until a generator takes over."
      },
      {
        question: "How long can a backup generator run during an outage?",
        answer: "Runtime depends on fuel tank size and connected load. Most standby generators can run for 8–72 hours on a full tank. We size generators to your specific load requirements and can advise on automatic fuel management and extended-run setups."
      },
      {
        question: "What is an Automatic Transfer Switch (ATS)?",
        answer: "An ATS detects mains power failure and automatically switches your electrical load to the backup generator — typically within 10–30 seconds, with no manual intervention required. It also switches back to mains power when supply is restored."
      },
      {
        question: "How often should standby generators be serviced?",
        answer: "We recommend a full service at least once per year, including load-testing, oil and filter changes, coolant check, and battery inspection. Monthly self-test runs (which most modern generators perform automatically) are also essential to ensure start-up reliability."
      }
    ]
  },
  {
    slug: "electrical-safety-compliance-auckland",
    name: "Electrical Safety & Compliance",
    headline: "Electrical Inspections & Code Compliance for Auckland Properties",
    metaTitle: "Electrical Safety & Compliance Auckland | CyberElectrix",
    metaDescription: "Electrical inspections, code compliance corrections & safety upgrades in Auckland. Ensure your property meets NZ electrical standards. CyberElectrix.",
    description: "Electrical inspections, code compliance corrections, installation protection upgrades, and personnel safety assessments for Auckland residential, commercial, and industrial properties. We help property owners, landlords, and businesses ensure their electrical systems fully meet current New Zealand safety standards and regulations.",
    benefits: [
      "Pre-purchase and landlord electrical inspections",
      "Code compliance certificate (CCC) support",
      "RCD and safety switch installation",
      "Electrical hazard identification and correction",
      "Switchboard safety upgrades",
      "Industrial electrical safety audits",
      "Insurance and compliance documentation",
      "Solar PV safety and compliance inspections"
    ],
    icon: "fa fa-shield",
    keywords: ["electrical inspection Auckland", "electrical compliance Auckland", "electrical safety Auckland", "code compliance electrician Auckland", "landlord electrical inspection Auckland", "RCD installation Auckland", "electrical safety audit Auckland"],
    faqs: [
      {
        question: "What does a pre-purchase electrical inspection cover?",
        answer: "A licensed electrician visually inspects the property's switchboard, wiring condition, earthing, RCD protection, and visible fittings. We identify non-compliant wiring, potential hazards, and items that would fail a formal inspection — giving you informed leverage before you buy."
      },
      {
        question: "How often do rental properties need electrical inspections in NZ?",
        answer: "Electrical Warrant of Fitness (eWOF) inspections are recommended every 1–3 years for NZ rental properties, depending on the age and condition of the installation. NZ tenancy law requires landlords to maintain safe electrical systems — CyberElectrix carries out eWOF inspections and remediates any faults found."
      },
      {
        question: "What is an RCD and is one required in NZ?",
        answer: "An RCD (Residual Current Device), also called a safety switch, cuts power within 30 milliseconds of detecting an earth fault — preventing electrocution. NZ regulations require RCD protection on all new and upgraded circuits, and we strongly recommend retrofitting them to older installations."
      },
      {
        question: "What happens if my property fails an electrical inspection?",
        answer: "We provide a written report of all faults and non-compliant items, prioritised by safety risk. We then quote to remediate all identified issues to bring your installation up to current NZ standards. We handle the full process from inspection to compliance sign-off."
      }
    ]
  },
  {
    slug: "emergency-electrician-auckland",
    name: "24/7 Emergency Electrician",
    headline: "Emergency Electrical Services Available 24/7 Across Auckland",
    metaTitle: "Emergency Electrician Auckland 24/7 | CyberElectrix",
    metaDescription: "24/7 emergency electrician in Auckland. Critical faults, urgent repairs, emergency circuit installations. Fast response from CyberElectrix — call now.",
    description: "Round-the-clock emergency electrical response across Auckland when you need it most. We handle critical faults requiring urgent repairs, emergency circuit installations, quick component and equipment swap-outs, and last-minute system integration assistance for residential, commercial, and industrial clients.",
    benefits: [
      "24/7 emergency call-out across Auckland",
      "Critical electrical fault diagnosis and repair",
      "Emergency circuit installation and isolation",
      "Urgent switchboard and fuse repairs",
      "After-hours residential emergency response",
      "Commercial and industrial emergency support",
      "Storm and flood damage electrical assessment",
      "Fast response — maximum 24-hour turnaround*"
    ],
    icon: "fa fa-clock-o",
    keywords: ["emergency electrician Auckland", "24/7 electrician Auckland", "emergency electrical Auckland", "urgent electrician Auckland", "after hours electrician Auckland", "emergency electrical repair Auckland"],
    faqs: [
      {
        question: "What counts as an electrical emergency?",
        answer: "Any situation posing immediate safety risk: total loss of power to critical systems, burning smell from a switchboard or outlet, sparking wiring, water ingress near electrical fittings, or any fault you suspect poses a fire or electrocution risk. If in doubt, call us — we'd rather you check."
      },
      {
        question: "How quickly can you respond to an emergency in Auckland?",
        answer: "We aim for a maximum 24-hour turnaround on emergency call-outs across Auckland. Response time depends on technician availability and your location. For life-safety electrical emergencies, always call 111 first if there is immediate danger."
      },
      {
        question: "Do you charge extra for after-hours emergency call-outs?",
        answer: "After-hours call-outs may include a call-out fee on top of the standard labour rate. We will always advise you of any additional charges before we proceed — no surprises."
      },
      {
        question: "What should I do while waiting for the emergency electrician?",
        answer: "If safe to do so, isolate the affected circuit at your switchboard. Do not attempt to investigate wiring yourself. If you smell burning or see smoke, evacuate immediately and call 111. Keep the area clear and ensure the electrician has safe access when they arrive."
      }
    ]
  }
];

export default services;
